import { HFlow, Text, VFlow } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'

export function NewsModalBodyLinks() {
  const {
    PILOTO_NOTIFICACAO_LOTACAO_ENABLED,
    PILOTO_INTEGRACAO_REGULACAO_ENABLED,
    PILOTO_LISTA_TEMATICA_ENABLED,
    CUIDADO_COMPARTILHADO_CIDADAO_OBITO_ENABLED,
    M_CHAT_ENABLED,
    PILOTO_ANEXO_ARQUIVOS_ENABLED,
    PILOTO_FICHA_SINAN_ENABLED,
    PILOTO_COMPARTILHAMENTO_EMULTI_ENABLED,
    PILOTO_NOVO_CONTADOR_TEMPO_CUIDADO_ENABLED,
  } = useFlags()

  return (
    <HFlow hSpacing={2}>
      <VFlow vSpacing={0.2}>
        {PILOTO_FICHA_SINAN_ENABLED && <Text component='li'>Atualização da Ficha de notificação de caso suspeito</Text>}
        {PILOTO_NOTIFICACAO_LOTACAO_ENABLED && (
          <Text component='li'>Notificações no módulo de Cuidado compartilhado</Text>
        )}
        {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
          <Text component='li'>Notificações no módulo de Regulação assistencial</Text>
        )}
        {PILOTO_INTEGRACAO_REGULACAO_ENABLED && <Text component='li'>Regulação assistencial</Text>}
        {PILOTO_LISTA_TEMATICA_ENABLED && <Text component='li'>Acompanhamento de condições de saúde</Text>}
        {CUIDADO_COMPARTILHADO_CIDADAO_OBITO_ENABLED && (
          <Text component='li'>Indicação de óbito na Garantia de acesso</Text>
        )}
        <Text component='li'>Relatório gerencial de exames</Text>
        {M_CHAT_ENABLED && <Text component='li'>Avaliação do M-CHAT-R na puericultura</Text>}
        {PILOTO_ANEXO_ARQUIVOS_ENABLED && <Text component='li'>Anexo de arquivos no prontuário</Text>}
        <Text component='li'>Gráficos de ganho de peso gestacional</Text>
        <Text component='li'>Relatórios de envios com sucesso</Text>
        <Text component='li'>Novo módulo de Atividade coletiva no PEC</Text>
        {(PILOTO_COMPARTILHAMENTO_EMULTI_ENABLED ||
          PILOTO_NOVO_CONTADOR_TEMPO_CUIDADO_ENABLED ||
          CUIDADO_COMPARTILHADO_CIDADAO_OBITO_ENABLED) && (
          <Text component='li'>Novas funcionalidades para o Cuidado compartilhado</Text>
        )}
        <Text component='li'>Atualização dos gráficos de peso e altura para crianças</Text>
        <Text component='li'>Atualização do gráfico de altura para adolescentes</Text>
        <Text component='li'>Atualizações em Temas para saúde no módulo de Atividade coletiva</Text>
        <Text component='li'>Exibição de registros anteriores e de outras fontes no módulo de Atividade coletiva</Text>
      </VFlow>
    </HFlow>
  )
}
